import { render, staticRenderFns } from "./formContactDropdownLabelInput.vue?vue&type=template&id=1fdb90f4&"
import script from "./formContactDropdownLabelInput.vue?vue&type=script&lang=js&"
export * from "./formContactDropdownLabelInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports